// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".revico-widget .revico-community-talk-post--reviewer-attribute-item {\n  margin: 12px 0 0 0;\n}\n.revico-widget .revico-community-talk-post--reviewer-attribute-item:first-child {\n  margin: 16px 0 0 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
